import React from "react";
import NavLink from "react-router-dom/NavLink";

const NavBar = () => {
  return (
    <nav className="navigationBox">
      <h6 className="bestView">NOTE: Best View - Google Chrome (1920x1080) resolution</h6>
      <h5>Navigation</h5>
      <div id="navbarNav">
        <ul>
          <li className="nav-item active">
            <NavLink className="nav-link" to="/main">
              Main <span className="sr-only">(current)</span>
            </NavLink>
          </li> 
          <li className="nav-item">
            <NavLink className="nav-link" to="/language2">
              Language
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/reason">
              Select Option
            </NavLink>
          </li> 
          <li className="nav-item">
            <NavLink className="nav-link" to="/generalregistration">
              Registration
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/returncard">
              Return card
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/blacklist">
              Black List
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/generalquestiontwo">
              Questionnaires
            </NavLink>
          </li> 
          <li className="nav-item">
            <NavLink className="nav-link" to="/successreg">
              Success 1
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/successreg2">
              Success 2
            </NavLink>
          </li> 
          <li className="nav-item">
            <NavLink className="nav-link" to="/accessdenied">
              System Denied
            </NavLink>
          </li>
        
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;